import { Controller } from 'stimulus'
import * as h from 'lib/helpers'

export default class Projects_ShowController extends Controller {
  static targets = ['status', 'statusIcon']

  refreshChangeableHtml() {
    h.callStimulusAction('.info-sidebar', 'refresh-content', 'refreshContent')
    h.callStimulusAction('.model-show-container', 'tab', 'refreshCurrentTab')
    h.callStimulusAction('.j-project-leaders', 'refresh-content', 'refreshContent')
  }
}
